import { ActionBrick, registerBrick } from 'olympe';
import $ from "jquery";
import "jquery-confirm";
import {getLogger} from "@olympeio/core";

export default class Alert extends ActionBrick {

    init(_) {
        const head  = document.getElementsByTagName('head')[0];

        const jqueryConfirmId = 'jquery-confirm';
        if (!document.getElementById(jqueryConfirmId)) {
            const jqueryConfirm  = document.createElement('link');
            jqueryConfirm.id   = jqueryConfirmId;
            jqueryConfirm.rel  = 'stylesheet';
            jqueryConfirm.type = 'text/css';
            jqueryConfirm.href = 'https://cdnjs.cloudflare.com/ajax/libs/jquery-confirm/3.3.2/jquery-confirm.min.css';
            jqueryConfirm.media = 'all';
            head.appendChild(jqueryConfirm);
        }

        const bootstrapId = 'bootstrap';
        if (!document.getElementById(bootstrapId)) {
            const bootstrap  = document.createElement('link');
            bootstrap.id   = bootstrapId;
            bootstrap.rel  = 'stylesheet';
            bootstrap.type = 'text/css';
            bootstrap.href = 'https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css';
            bootstrap.media = 'all';
            head.appendChild(bootstrap);
        }
    }

    /**
     * @protected
     * @param {!BrickContext} context
     * @param {string} title
     * @param {string} text
     * @param {string} btnText
     * @param {string} color
     * @param {function()} forwardEvent
     */
    update(context, [title, text, btnText, color], [forwardEvent]) {
        // Escaping inputs
        title = title || '';
        text = text || '';
        btnText = btnText || 'Ok';

        let colorType;
        switch (color) {
            case 'green':
            case 'red':
            case 'blue':
            case 'orange':
            case 'purple':
            case 'dark':
                colorType = color; break;
            default: colorType = 'default';
        }

        if(typeof title === 'object' || typeof text === 'object' || typeof btnText === 'object'){
            getLogger('Alert').error('Type of all parameters from alert should be string');
            return;
        } else {
            title = String(title);
            text = String(text);
            btnText = String(btnText);
        }

        // Displaying the popup
        $.alert({
            title: title,
            content: text,
            type: colorType,
            columnClass: 'medium',
            buttons: {
                confirm: {
                    text: btnText,
                    btnClass: 'btn-'+ colorType,
                    keys: ['enter'],
                    action: function () {
                        forwardEvent();
                    }
                }
            }
        });
    }
}

registerBrick('017b2b771ddb1d65dfcc', Alert);
